module.exports = __webpack_public_path__ + "img/Student-Corner.38869834.png";